<template>
  <div class="country-select mb-3 " ref="dropdown">
    <div class="selected" @click="toggleDropdown">
      <span v-if="selectedCountry">
        <img :src="selectedCountry.flag" class="flag" />
        {{ selectedCountry.name }}
      </span>
      <span v-else>{{ $t('country') }}</span>
      <i class="arrow"></i>
    </div>

    <div v-if="isOpen" class="dropdown">
      <input
          type="text"
          v-model="search"
          placeholder="Search..."
          class="search-input"
      />

      <ul>
        <li
            v-for="country in filteredCountries"
            :key="country.code"
            @click="selectCountry(country)"
        >
          <img :src="country.flag" class="flag" />
          {{ country.name }}
        </li>

        <li v-if="filteredCountries.length === 0" class="no-result">
          not found
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "CountrySelect",
  props: {
    value: String
  },
  data() {
    return {
      isOpen: false,
      search: "",
      countries: []
    };
  },
  computed: {
    filteredCountries() {
      return this.countries.filter(c =>
          c.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    selectedCountry() {
      return this.countries.find(c => c.code === this.value);
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectCountry(country) {
      this.$emit("input", country.code);
      this.isOpen = false;
      this.search = "";
    },
    handleClickOutside(e) {
      if (!this.$refs.dropdown.contains(e.target)) {
        this.isOpen = false;
      }
    },
    async fetchCountries() {
      try {
        const res = await fetch("https://restcountries.com/v3.1/all?fields=name,flag,cca2");
        const data = await res.json();

        this.countries = data
            .map(c => ({
              name: c.name.common,
              code: c.cca2,
              flag: "https://flagcdn.com/w320/"+c.cca2.toLocaleLowerCase()+".png"
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
      } catch (error) {
        console.error("error get countries:", error);
      }
    }
  },
  mounted() {
    this.fetchCountries();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.country-select {
  position: relative;
  width: 100%;
}

.selected {
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
}

.dropdown {
  position: absolute;
  width: 100%;
  border: 1px solid #ccc;
  background: #fff;
  max-height: 300px;
  overflow-y: auto;
  z-index: 10;
}

.search-input {
  width: 100%;
  padding: 6px;
  border: none;
  border-bottom: 1px solid #eee;
  outline: none;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

li:hover {
  background: #f2f2f2;
}

.flag {
  width: 20px;
  margin-right: 8px;
}

.no-result {
  text-align: center;
  color: #888;
}

.arrow::after {
  content: "▼";
  font-size: 10px;
}
</style>